import gsap from 'gsap'
import $ from 'jquery'
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'
import { Accordion } from 'fonts/components/Accordion'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class CareerRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    // store.resizeFn = this.onResize.bind(this);
    // qs(".disclaimer") && qs(".disclaimer").classList.remove("hide");
    store.resizeFn = null
    store.section = 'terms'
    Accordion('brand-values-accordion')
    this.setHeaderStyle('white')
    this.onPageChange()
    this.initSlide()
    this.setUpCareers()
    this.setUpVideo()
    qsa('.go-open-jobs').forEach((elem) => {
      elem.addEventListener('click', () => {
        document.querySelector('#open-jobs').scrollIntoView({
          behaviour: 'smooth',
          block: 'nearest',
          inline: 'start',
        })
      })
    })
  }

  setLocation() {
    const params = new URLSearchParams(document.location.search)
    const office = params.get('office')

    const $dropdown = qs('#locations-select')

    const location = $dropdown.querySelector('option[value="' + office + '"]')
    if (location) {
      $dropdown.selectedIndex = location.index
      const e = new Event('change')
      $dropdown.dispatchEvent(e)
    }
  }

  onEnter() {
    super.onEnter()
    // qs(".disclaimer").classList.remove("hide");
    // qs(".disclaimer").classList.add("careers");
  }

  onLeave() {
    super.onLeave()
    // qs(".disclaimer").classList.add("hide");
    // qs(".disclaimer").classList.remove("careers");
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
    this.setLocation()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
    // qs(".disclaimer") && qs(".disclaimer").classList.add("hide");
  }

  initSlide() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 2000,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }

    const workHumansSlide = new Swiper('.careers-slide.humans', {
      slidesPerView: 'auto',
      spaceBetween: 85,
      centeredSlides: true,
      disableOnInteraction: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: false,
      speed: 1000,
      autoplayDisableOnInteraction: true,
      ...autoplayObj,
    })
    $('.humans ~ .button.controls').click(function () {
      if (this.classList.contains('pause')) {
        this.classList.remove('pause')
        this.classList.add('play')
        this.innerHTML = 'PLAY'
        workHumansSlide.autoplay.stop()
      } else {
        this.classList.remove('play')
        this.classList.add('pause')
        this.innerHTML = 'PAUSE'
        workHumansSlide.autoplay.start()
      }
    })
    const workPetsSlide = new Swiper('.careers-slide.pets', {
      slidesPerView: 'auto',
      spaceBetween: 85,
      centeredSlides: true,
      disableOnInteraction: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      autoplayDisableOnInteraction: true,
      ...autoplayObj,
    })
    $('.pets ~ .button.controls').click(function () {
      if (this.classList.contains('pause')) {
        this.classList.remove('pause')
        this.classList.add('play')
        this.innerHTML = 'PLAY'
        workPetsSlide.autoplay.stop()
      } else {
        this.classList.remove('play')
        this.classList.add('pause')
        this.innerHTML = 'PAUSE'
        workPetsSlide.autoplay.start()
      }
    })

    const videoSlide = new Swiper('.video-slide ', {
      slidesPerView: 1,
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      on: {
        slideChange: function () {
          if (this.pagination.bullets) {
            this.pagination.bullets.forEach((el, index) =>
              el.setAttribute('aria-current', `${index === this.realIndex}`),
            )
          }
        },
        paginationRender: function (swiper, el) {
          el.querySelectorAll('.swiper-pagination-bullet').forEach(function (child) {
            child.setAttribute(
              'aria-label',
              child.getAttribute('aria-label').replace('total', swiper.pagination.bullets.length),
            )
          })
        },
      },
      pagination: {
        el: '.video-slide-dots',
        clickable: true,
        renderBullet: function (index, className) {
          const ariaLabel = `go to text ${index + 1} out of total`
          const ariaCurrent = index === 0 ? ' aria-current="true" ' : ''
          return (
            '<button ' +
            ariaCurrent +
            ' class="' +
            className +
            '" aria-label="' +
            ariaLabel +
            '"></button>'
          )
        },
        // renderBullet: function(index, className) {
        //     return '<span class="' + className + '">' +
        //         '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
        //         '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
        //         'stroke-opacity="1" stroke-width="1.5px"></circle>' +
        //         '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
        //         '</svg></span>';
        // },
      },
    })
  }

  setUpCareers() {
    const $departments = qsa('.job-deparment')
    const $jobs = qsa('.f-c-r-row')

    const $dropdown = qs('#locations-select')
    const $viewMore = qs('#load-more-jobs')
    // const lastPage = qs(".f-c-r-row:last-child").dataset.page;

    // let page = 2;

    $dropdown.addEventListener('change', (e) => {
      const $dept = qs('.job-deparment.active')
      const id = $dept.dataset.department
      const selectedLocation = e.target.value.trim()
      gsap.to($jobs, {
        opacity: 0,
        y: 20,
        duration: 0.3,
        onComplete: () => {
          const $toShow =
            id === 'all' ? qsa(`.f-c-r-row`) : qsa(`.f-c-r-row[data-department="${id}"]`)

          let $toShowFiltered = selectedLocation
            ? Array.prototype.slice.call($toShow).filter((job) => {
                return job?.querySelector('.location').textContent.trim() === selectedLocation
              })
            : $jobs

          const $toHide = id === 'all' ? [] : qsa(`.f-c-r-row:not([data-department="${id}"])`)

          let $toHideFiltered = selectedLocation
            ? Array.prototype.slice.call($toShow).filter((job) => {
                return job?.querySelector('.location').textContent.trim() !== selectedLocation
              })
            : $toHide

          if ($toShowFiltered.length > 0) {
            gsap.set(qsa('#no-results'), { display: 'none' })
          } else {
            gsap.set(qsa('#no-results'), { display: 'block' })
          }

          $toShowFiltered = [...$toShowFiltered].map((job, i) => {
            job['data-page'] = Math.ceil(i / 5) + 1
            console.log({ job })
            return job
          })
          gsap.set($toShowFiltered, { display: 'block' })
          gsap.set($toHide, { display: 'none' })
          gsap.set($toHideFiltered, { display: 'none' })
          gsap.to($toShowFiltered, {
            opacity: 1,
            y: 0,
            duration: 0.3,
            stagger: 0.1,
            onComplete: () => {
              // if (id !== "all") {
              //   $viewMore.classList.add("hide");
              // } else {
              //   $viewMore.classList.remove("hide");
              //   qsa(`.f-c-r-row:not([data-page="1"])`).forEach((j) => {
              //     j.style.display = "none";
              //     j.style.opacity = 0;
              //     j.style.transform = "translateY(20px)";
              //   });
              //   page = 2;
              //}
            },
          })
        },
      })
      // gsap.to($jobs, {
      //   opacity: 0,
      //   y: 20,
      //   duration: 0.3,
      //   onComplete: () => {
      //     const $toShow =
      //       id === "all"
      //         ? qsa(".f-c-r-row")
      //         : qsa(`.f-c-r-row[data-department="${id}"]`);
      //     debugger;
      //     let $toShowFiltered = selectedLocation
      //       ? Array.prototype.slice.call($toShow).filter((job) => {
      //           return (
      //             job?.querySelector(".location").textContent.trim() ===
      //             selectedLocation
      //           );
      //         })
      //       : $toShow;
      //     $toShowFiltered = [...$toShowFiltered].map((job, i) => {
      //       job["data-page"] = Math.ceil(i / 5) + 1;
      //       return job;
      //     });

      //     const $toHide =
      //       id === "all"
      //         ? []
      //         : qsa(`.f-c-r-row:not([data-department="${id}"])`);

      //     if ($toShowFiltered.length > 0) {
      //       gsap.set(qsa("#no-results"), { display: "none" });
      //     } else {
      //       gsap.set(qsa("#no-results"), { display: "block" });
      //     }

      //     gsap.set($toShowFiltered, { display: "block" });
      //     gsap.set($toHide, { display: "none" });
      //     debugger;
      //     gsap.to($toShowFiltered, {
      //       opacity: 1,
      //       y: 0,
      //       duration: 0.3,
      //       stagger: 0.1,
      //       onComplete: () => {
      //         if (id !== "all") {
      //           $viewMore.classList.add("hide");
      //         } else {
      //           $viewMore.classList.remove("hide");
      //           debugger;
      //           qsa(`.f-c-r-row:not([data-page="1"])`).forEach((j) => {
      //             j.style.display = "none";
      //             j.style.opacity = 0;
      //             j.style.transform = "translateY(20px)";
      //           });
      //           page = 2;
      //         }
      //       },
      //     });
      //   },
      // });
    })
    $departments.forEach((d) => {
      d.addEventListener('click', () => {
        const id = d.dataset.department
        $departments.forEach((d) => {
          d.classList.remove('active')
          d.setAttribute('aria-current', 'false')
        })
        d.classList.add('active')
        d.setAttribute('aria-current', 'true')
        const selectedLocation = document.getElementById('locations-select').value

        gsap.to($jobs, {
          opacity: 0,
          y: 20,
          duration: 0.3,
          onComplete: () => {
            const $toShow =
              id === 'all' ? qsa(`.f-c-r-row`) : qsa(`.f-c-r-row[data-department="${id}"]`)

            let $toShowFiltered = selectedLocation
              ? Array.prototype.slice.call($toShow).filter((job) => {
                  return job?.querySelector('.location').textContent.trim() === selectedLocation
                })
              : $jobs

            $toShowFiltered = [...$toShowFiltered].map((job, i) => {
              job['data-page'] = Math.ceil(i / 5) + 1
              return job
            })
            const $toHide = id === 'all' ? [] : qsa(`.f-c-r-row:not([data-department="${id}"])`)

            if ($toShowFiltered.length > 0) {
              gsap.set(qsa('#no-results'), { display: 'none' })
            } else {
              gsap.set(qsa('#no-results'), { display: 'block' })
            }

            gsap.set($toShowFiltered, { display: 'block' })
            gsap.set($toHide, { display: 'none' })
            gsap.to($toShowFiltered, {
              opacity: 1,
              y: 0,
              duration: 0.3,
              stagger: 0.1,
              onComplete: () => {
                // if (id !== "all") {
                //   $viewMore.classList.add("hide");
                // } else {
                //   $viewMore.classList.remove("hide");
                //   qsa(`.f-c-r-row:not([data-page="1"])`).forEach((j) => {
                //     j.style.display = "none";
                //     j.style.opacity = 0;
                //     j.style.transform = "translateY(20px)";
                //   });
                //   page = 2;
                // }
              },
            })
          },
        })
      })
    })

    // $viewMore.addEventListener("click", () => {
    //   if (page >= lastPage) {
    //     $viewMore.classList.add("hide");
    //   }
    //   const $toShow = qsa(`.f-c-r-row[data-page="${page}"]`);
    //   $toShow.forEach((elem) => (elem.style.display = "block"));
    //   gsap.to($toShow, {
    //     opacity: 1,
    //     y: 0,
    //     duration: 0.3,
    //     stagger: 0.1,
    //   });
    //   page++;
    // });
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')

    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)
      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
          $mask.classList.add('active')
        }
      })
    })
  }
}

export default CareerRenderer
